export class FileUpload {
  constructor() {
    this._files = document.querySelectorAll('[data-file]');
    this._filesArray = null;

    this._documentClickHandler = this._documentClickHandler.bind(this);
    this._onInputClick = this._onInputClick.bind(this);
    this._onInputChange = this._onInputChange.bind(this);

    this._size = 'Кб';
    this._ariaLabel = 'Удалить файл';
  }

  init() {
    if (!this._files.length) {
      return;
    }

    this._files.forEach((file) => {
      this._initFile(file);
    });

    document.addEventListener('click', this._documentClickHandler);
  }

  _initFile(file) {
    const input = file.querySelector('[data-file-input]');
    const button = file.querySelector('[data-file-button]');
    const info = file.querySelector('[data-file-info]');

    const filesArray = Array.from(input.files);

    if (filesArray.length) {
      info.innerHTML = '';
      file.classList.add('is-upload');
      if (filesArray.length > 1) {
        button.innerHTML = 'Добавить файлы';
        info.innerHTML = filesArray.reduce((result, current) => result + `
          <span class="form-row__info-text" data-file-text>
            <span class="form-row__file-name">${current.name}</span>
            <span class="form-row__file-size">${(current.size / 1024).toFixed(2)} ${this._size}</span>
            <button class="form-row__file-delete" type="button" aria-label="${this._ariaLabel}" data-file-delete>
              <svg width="12" height="12" aria-hidden="true">
                <use xlink:href="#icon-close"></use>
              </svg>
            </button>
          </span>`, '');
      } else {
        button.innerHTML = 'Заменить файл';
        info.innerHTML = `
          <span class="form-row__info-text" data-file-text>
            <span class="form-row__file-name">${filesArray[0].name}</span>
            <span class="form-row__file-size">${(filesArray[0].size / 1024).toFixed(2)} ${this._size}</span>
            <button class="form-row__file-delete" type="button" aria-label="${this._ariaLabel}" data-file-delete>
              <svg width="12" height="12" aria-hidden="true">
                <use xlink:href="#icon-close"></use>
              </svg>
            </button>
          </span>`;
      }
    } else {
      if (input.multiple) {
        button.innerHTML = 'Добавить файлы';
      } else {
        button.innerHTML = 'Добавить файл';
      }
    }

    input.addEventListener('click', this._onInputClick);
    input.addEventListener('change', this._onInputChange);
  }

  _onInputClick(evt) {
    this._filesArray = evt.target.files;
  }

  _onInputChange(evt) {
    const input = evt.target;
    const parent = input.closest('[data-file]');
    const button = parent.querySelector('[data-file-button]');
    const info = parent.querySelector('[data-file-info]');
    const extensions = parent.dataset.fileAccept;

    let error = false;
    let files = Array.from(evt.target.files);

    info.innerHTML = '';

    if (files.length) {
      if (files.length === 1) {
        if (extensions) {
          error = this._checkFileExtension(extensions, files[0].type);
        }
      } else {
        files.forEach((file) => {
          if (extensions) {
            error = this._checkFileExtension(extensions, file.type);
          }
        });
      }
    }

    if (error) {
      info.innerHTML = `
          <span class="form-row__info-text">
            <span class="form-row__file-name" style="color: red;">Недопустимый формат файла</span>
          </span>`;
      return;
    }

    if (input.multiple && this._filesArray.length) {
      files = files.concat(Array.from(this._filesArray));

      const dataTransfer = new DataTransfer();
      files.forEach((file) => {
        dataTransfer.items.add(file);
      });
      input.files = dataTransfer.files;
    }

    if (files.length) {
      info.innerHTML = '';
      parent.classList.add('is-upload');

      if (files.length > 1) {
        button.innerHTML = 'Добавить файлы';
        info.innerHTML = files.reduce((result, current) => result + `
        <span class="form-row__info-text" data-file-text>
          <span class="form-row__file-name">${current.name}</span>
          <span class="form-row__file-size">${(current.size / 1024).toFixed(2)} ${this._size}</span>
          <button class="form-row__file-delete" type="button" aria-label="${this._ariaLabel}" data-file-delete>
            <svg width="12" height="12" aria-hidden="true">
              <use xlink:href="#icon-close"></use>
            </svg>
          </button>
        </span>`, '');
      } else {
        button.innerHTML = 'Заменить файл';
        info.innerHTML = `
          <span class="form-row__info-text" data-file-text>
          <span class="form-row__file-name">${files[0].name}</span>
          <span class="form-row__file-size">${(files[0].size / 1024).toFixed(2)} ${this._size}</span>
          <button class="form-row__file-delete" type="button" aria-label="${this._ariaLabel}" data-file-delete>
            <svg width="12" height="12" aria-hidden="true">
              <use xlink:href="#icon-close"></use>
            </svg>
          </button>
        </span>`;
      }
    } else {
      parent.classList.remove('is-upload');
      if (input.multiple) {
        button.innerHTML = 'Добавить файлы';
      } else {
        button.innerHTML = 'Добавить файл';
      }
    }
  }

  _checkFileExtension(extensions, fileType) {
    const list = extensions.split(', ');

    let isNotError = true;

    list.forEach((item) => {
      if (fileType.includes(item.substr(1))) {
        isNotError = false;
      }
    });

    return isNotError;
  }

  _documentClickHandler(evt) {
    const target = evt.target;

    if (!target.closest('[data-file-delete]')) {
      return;
    }

    const fileElement = target.closest('[data-file]');
    const oldInput = fileElement.querySelector('[data-file-old-input]');
    const input = fileElement.querySelector('[data-file-input]');
    const info = fileElement.querySelector('[data-file-info]');
    const fileText = target.closest('[data-file-text]');

    if (input.multiple) {
      const files = Array.from(input.files);

      if (files.length > 1) {
        const dataTransfer = new DataTransfer();

        files.forEach((file) => {
          if (file.name !== fileText.innerText.split('\n')[0]) {
            dataTransfer.items.add(file);
          } else {
            fileText.remove();
          }
        });

        input.files = dataTransfer.files;
      } else {
        oldInput.value = '';
        input.value = '';
        info.innerHTML = '';
        fileElement.classList.remove('is-upload');
      }
    } else {
      oldInput.value = '';
      input.value = '';
      info.innerHTML = '';
      fileElement.classList.remove('is-upload');
    }
  }
}
